<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
            <dt>Science & Technology Are The Primary Productive Forces<br /><br /></dt>
        <dd class="sub_title">Research Science Support:</dd>
        <dd>1. Academic Support by Qingdao University of Science and Technology and Harbin Institute of Technology. Technology Support by experienced premium-brands senior engineers and European technical team.</dd>
        <dd>2. Establish mid-term to long-term technological development strategies while conducting innovative research.</dd>
        <dd>3. Manage research results by observing, computing, recording and interpreting the results and analyses of experiments.</dd>
        <dd>4. Monitor the progress of experiments and analyze the results.</dd>
        <dd class="sub_title">Product R & D:</dd>
        <dd>1. Perform scientific and technological investigations based on theories and experiments for product and process research and development.</dd>
        <dd>2. Develop and assess new concepts and technologies to create solutions to known problems.</dd>
        <dd>3. Create a database of technical issues that have been resolved and prepare documents related to result analysis, such as technical research reports, summaries, lab reports (proposals), and quantitative analysis.</dd>
        <dd>4. Plan specific methodology and procedures for experiment and perform collaborative research and share information with in-house researchers and other science experts.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "RND_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
.sub_title {
    color: red;
}
</style>




// WEBPACK FOOTER //
// src/components/company/rnd_content.vue